module.exports = __webpack_public_path__ + "img/mapThumb.a7a75b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mapThumb.png
// module id = 8J25
// module chunks = 8